import { logger } from '../logger';

export class DbRecord {
  private static instance: DbRecord;
  private indexDBName = 'RecordContestPaper';
  private request: IDBOpenDBRequest | null = null;
  private db: IDBDatabase | null = null;

  private constructor() {
    this.request = window.indexedDB.open(this.indexDBName, 1);
    this.request.onerror = event => {
      logger.error('数据库打开报错');
    };
    this.request.onsuccess = event => {
      logger.log('数据库打开成功');
      this.db = this.request ? this.request.result : null;
    };
    this.request.onupgradeneeded = event => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains('videoChunks')) {
        db.createObjectStore('videoChunks', { keyPath: 'id' });
      }
    };
  }

  public static getInstance(): DbRecord {
    if (!DbRecord.instance) {
      DbRecord.instance = new DbRecord();
    }
    return DbRecord.instance;
  }

  private getObjectStore(
    storeName: string,
    mode: IDBTransactionMode
  ): IDBObjectStore | null {
    if (!this.db) {
      logger.error('数据库未打开');
      return null;
    }
    const transaction = this.db.transaction(storeName, mode);
    return transaction.objectStore(storeName);
  }

  public async addRecord(
    { data, recordFormatTime }: { data: any; recordFormatTime: string },
    index = 0
  ) {
    const store = this.getObjectStore('videoChunks', 'readwrite');
    if (!store) return;

    const request = store.add({
      id: Date.now(),
      chunk: data,
    });
    request.onerror = () => {
      logger.error('添加记录失败', index, recordFormatTime);
      // 尝试重新添加
      if (index === 0) {
        this.addRecord({ data, recordFormatTime }, 1);
      }
    };
    request.onsuccess = event => {
      logger.log('添加记录成功', recordFormatTime);
    };
  }

  public async deleteRecord(id: number) {
    const store = this.getObjectStore('videoChunks', 'readwrite');
    if (!store) return;

    const request = store.delete(id);
    request.onerror = event => {
      logger.error('删除记录失败');
    };
    request.onsuccess = event => {
      logger.log('删除记录成功');
    };
  }

  public async clearRecords() {
    const store = this.getObjectStore('videoChunks', 'readwrite');
    if (!store) return;

    const request = store.clear();
    request.onerror = event => {
      logger.error('清空记录失败');
    };
    request.onsuccess = event => {
      logger.log('清空记录成功');
    };
  }

  public async getCacheChunks(): Promise<any> {
    const store = this.getObjectStore('videoChunks', 'readonly');
    if (!store) return [];

    return new Promise((resolve, reject) => {
      const request = store.openCursor();
      const chunks: any[] = [];
      request.onerror = event => {
        reject();
      };
      request.onsuccess = event => {
        const cursor = (event.target as IDBRequest)?.result;
        if (cursor) {
          // console.log(cursor.value.chunk);
          chunks.push(cursor.value.chunk);
          cursor.continue();
        } else {
          resolve(chunks);
        }
      };
    });
  }
}
